export enum HeaderFlags {
  None = 0,
  LogoVisibleXS = 1, // logo visible at all resolutions
  LogoVisibleSM = 2, // logo will be hidden below 'small' resolution
  HamburgerMenu = 4,
  Customer = 8,
  MenuNav = 16,
  ReturnToRoute = 32,
  FindChipotleLeft = 64,
  FindChipotleRight = 128,
  Bag = 256,
  All = 511,
}

export interface HeaderOptions {
  flags: HeaderFlags;
  route?: string;
  routeText?: string;
}

export enum FooterMode {
  Normal = 'normal',
  Micro = 'micro',
  None = 'none',
}

export interface FooterOptions {
  mode: FooterMode;
}
